import React from 'react';
import { WDHImage } from '@demant/wdh';

var Image = function Image(_ref) {
  var imageData = _ref.imageData,
      linkData = _ref.linkData;
  return linkData && /*#__PURE__*/React.createElement("a", {
    href: linkData.href
  }, /*#__PURE__*/React.createElement(WDHImage, imageData));
};

export default Image;